export default {
	WORKPLACE_TO_POS_CONFIGURATION_ADDED:
		'Workplace to POS configuration relation added',
};
